import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Css/HealthEquitySupport.css";
import VTSevaLogo from "../Assets/VTSevaPartner.jpg";

const HealthEquitySupport = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Health Equity Support | SportsForEquity";

    let metaDescription = document.querySelector('meta[name="description"]');
    let createdMeta = false;
    const prevDescription = metaDescription ? metaDescription.getAttribute("content") : null;

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
      createdMeta = true;
    }
    metaDescription.setAttribute(
      "content",
      "SportsForEquity runs table-tennis coaching camps that direct proceeds to VT Seva's public health-equity initiatives, expanding access to lifesaving care for underserved communities."
    );

    return () => {
      document.title = prevTitle;
      if (createdMeta) {
        metaDescription.remove();
      } else if (prevDescription !== null) {
        metaDescription.setAttribute("content", prevDescription);
      }
    };
  }, []);

  const chapters = [
    {
      location: "Seattle, WA",
      status: "past",
      statusLabel: "Past Event",
    },
    {
      location: "Tri-Valley, CA",
      status: "past",
      statusLabel: "Past Event",
    },
    {
      location: "San Jose, CA",
      status: "ongoing",
      statusLabel: "Ongoing",
    },
  ];

  return (
    <div className="hes-page">

      {/* ── Hero ─────────────────────────────────────────────── */}
      <section className="hes-hero">
        <div className="hes-hero-text">
          <div className="hes-hero-title-row">
            <a
              href="https://www.vtsworld.org/branch/seattle"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={VTSevaLogo}
                alt="VT Seva Logo"
                className="hes-hero-logo"
              />
            </a>
            <h1 className="hes-title">VT Seva</h1>
          </div>
          <p className="hes-tagline">
            VT Seva is a national 501(c)(3) nonprofit powered by youth volunteerism, compassion, and community service. With 24+ U.S. centers and a worldwide network, VT Seva uplifts underserved communities through health camps and leadership programs. United by the belief that service transforms lives, volunteers work locally and globally to create lasting, measurable impact.
          </p>
        </div>
      </section>

      {/* ── About Our Program ────────────────────────────────── */}
      <section className="hes-section">
        <h2 className="hes-section-heading">About Our Program</h2>
        <p className="hes-body">
          SportsForEquity runs table‑tennis coaching camps that direct proceeds to VT Seva’s public health‑equity initiatives, including free community health camps and preventive‑care programs. Through sport and service, we help expand access to lifesaving care for underserved communities.
        </p>
        <p className="hes-body">
          For session schedules or to register your interest, please contact{" "}
          <a href="mailto:info@sportsforequity.live" className="hes-link">
            info@sportsforequity.live
          </a>.
        </p>
      </section>

      {/* ── Chapters & Events ────────────────────────────────── */}
      <section className="hes-section">
        <h2 className="hes-section-heading">&#11088; Health Equity Support — Chapters &amp; Events</h2>

        <div className="hes-chapters-grid">
          {/* Past Events */}
          <div className="hes-chapter-group">
            <h4 className="hes-group-label hes-group-label--past">Past Events</h4>
            {chapters
              .filter((c) => c.status === "past")
              .map((chapter, i) => (
                <div key={i} className="hes-chapter-card hes-chapter-card--past">
                  <span className="hes-chapter-dot hes-chapter-dot--past"></span>
                  <span className="hes-chapter-location">{chapter.location}</span>
                  <span className="hes-chapter-badge hes-chapter-badge--past">
                    {chapter.statusLabel}
                  </span>
                </div>
              ))}
          </div>

          {/* Ongoing */}
          <div className="hes-chapter-group">
            <h4 className="hes-group-label hes-group-label--ongoing">Ongoing</h4>
            {chapters
              .filter((c) => c.status === "ongoing")
              .map((chapter, i) => (
                <div key={i} className="hes-chapter-card hes-chapter-card--ongoing">
                  <span className="hes-chapter-dot hes-chapter-dot--ongoing"></span>
                  <span className="hes-chapter-location">{chapter.location}</span>
                  <span className="hes-chapter-badge hes-chapter-badge--ongoing">
                    {chapter.statusLabel}
                  </span>
                </div>
              ))}
          </div>
        </div>

        <Link to="/donate" className="hes-contribute-btn">
          Contribute To Healthcare Support
        </Link>
      </section>

    </div>
  );
};

export default HealthEquitySupport;